import { useMutation } from '@tanstack/react-query';

import { notifyAttendeesOfDateChange } from 'services/EventNotifications';

export interface NotifyAttendeesVars {
	eventIds: string[];
	/** Optional organizer note shown at the top of the email. */
	customMessage?: string;
}

// Shared across all four event-edit surfaces (green sub-page, green accordion, legacy-punchup, red
// standalone). Zone-neutral by design: it lives in common/ and owns no feedback, so each caller wires
// its own zone-appropriate toast/flash via react-query per-call options (postToast, accordion flash, or
// silent in the red zone). Fired only after a successful event save.
export const useNotifyAttendeesOnDateChange = () => {
	const { mutateAsync: notifyAsync, isLoading: isNotifying } = useMutation(
		({ eventIds, customMessage }: NotifyAttendeesVars) =>
			notifyAttendeesOfDateChange({ event_ids: eventIds, custom_message: customMessage || undefined })
	);

	return { notifyAsync, isNotifying };
};
